import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SidenavService } from '../../services/sidenav.service';
import { NgFor, NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-remotelist-sidemenu',
    templateUrl: './remotelist-sidemenu.component.html',
    styleUrls: ['./remotelist-sidemenu.component.scss'],
    imports: [NgFor, NgIf, MatButton, TranslatePipe]
})
export class RemotelistSidemenuComponent implements OnInit {

  /**
* @property remote list capabilities as input
*/
  @Input() remoteListCapabilities: object;


  /**
     * @property it holds list of capabilities
     */
  public capabilities: Array<any> = [];

  constructor(
    private sidenav: SidenavService,
  ) { }


  /**
  * @function clickOnCancel closes the side nav when called
  **/
  public clickOnCancel(): void {
    this.capabilities.forEach(listItem => {
        listItem.opened = false;
    });
    this.sidenav.close();
  }
/**
  * @function getList prepares a Dispaly name for side nav list items.
  **/
  getList(key: string, list: any) {
    const arry = list.map(listItem => {
      return {
        ...listItem,
        displayName: this.getDisplayNameOfRemoteListItem(listItem.name)
      };
    });
    return arry;
  }
/**
  * @function isExistDisplayableListItems it filters the remote list capabilities based on flag value
  **/

  isExistDisplayableListItems(obj) {
    return obj.list.some(item => item.value);
  }
/**
  * @function  getDisplayNameOfRemoteListItem it actually returns formatted display name by taking input as a key.
  **/

  public getDisplayNameOfRemoteListItem(key: string) {
    let str = key;
    str = str.charAt(0).toUpperCase() + str.slice(1);
    str = str.replace(/([A-Z])/g, ' $1').trim();
    return str;
  }

  ngOnInit() {
    if (this.remoteListCapabilities) {
      for (const [key, value] of Object.entries(this.remoteListCapabilities)) {
        const obj = {
          key: key,
          list: this.getList(key, value),
          name: this.getDisplayNameOfRemoteListItem(key),
          opened: false
        };
        if (this.isExistDisplayableListItems(obj)) {
          this.capabilities.push(obj);
        }
      }

    }
  }
/**
  * @function  updateSelectedCapabilityStatus it actually update the open status of the capability list items.
  **/
  public updateSelectedCapabilityStatus(item) {
    this.capabilities.forEach(listItem => {
      if (listItem.key === item.key) {
        listItem.opened = !listItem.opened;
      }
    });
  }

}
